import React, { useCallback, useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

import { isMobile } from 'react-device-detect';

import { getStorage, ref, getDownloadURL } from "firebase/storage";

import { Document, Page } from 'react-pdf';
import { pdfjs } from 'react-pdf';

import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';

pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/react-pdf/pdf.worker.js`;

const PDFViewer = () => {
  const location  = useLocation();

  const [pdfUrl, setPdfUrl]   = useState(null);
  const [error, setError]     = useState(null);
  const [loading, setLoading] = useState(true);

  // 🔹 (모바일) PDF 뷰어 상태 관리
  const [numPages, setNumPages] = useState(null);;
  const [scale, setScale]       = useState(1);

  // 🔹 (모바일) PDF 뷰어 사이즈 조정
  useEffect(() => {
    const handleResize = () => {
      setScale(window.innerWidth / 720); // 720: PDF 생성 시 고정된 너비값
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // 🔹 (모바일) 페이지 수 설정 (모든 페이지 반환 목적)
  const onLoadSuccess = useCallback(({ numPages }) => {
    setNumPages(numPages);
  }, []);

  // 🔹 (모바일) 에러
  const onLoadError = useCallback((error) => {
    console.error("PDF 로딩 실패:", error);
  }, []);

  // 🔹 (모바일) PDF 문서 내의 링크 클릭 이벤트 처리
  const handleLinkClick = (event, url) => {
    event.preventDefault();
    window.open(url, '_blank');
  };

  // 쿼리 파라미터에서 파싱한 값들을 저장할 상태 추가
  // const [parsedUID, setParsedUID] = useState('');
  // const [parsedMusicardID, setParsedMusicardID] = useState('');
  // const [parsedTimestamp, setParsedTimestamp] = useState('');

  // 현재 페이지 URL을 공유 URL로 사용
  // const shareUrl = window.location.href;

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    // id 파라미터 형식: [UID]-[musicardID]-[timestamp]
    const fileId = searchParams.get('id');
    if (!fileId) {
      setError('파일 식별자(id)가 제공되지 않았습니다.');
      setLoading(false);
      return;
    }
    const parts = fileId.split('-');
    if (parts.length < 3) {
      setError('잘못된 파일 식별자 형식입니다.');
      setLoading(false);
      return;
    }
    const uid = parts[0];
    const musicardID = parts[1];
    const timestamp = parts.slice(2).join('-');
    // setParsedUID(uid);
    // setParsedMusicardID(musicardID);
    // setParsedTimestamp(timestamp);

    // Firebase Storage 파일 경로: /users/[UID]/[musicardID]_portfolio_[timestamp].pdf
    const filePath = `/users/${uid}/${musicardID}_portfolio_${timestamp}.pdf`;
    const storage = getStorage();
    const fileRef = ref(storage, filePath);

    getDownloadURL(fileRef)
      .then((url) => {
        setPdfUrl(url);
        setLoading(false);
      })
      .catch((err) => {
        setError(`PDF를 로드하는데 실패했습니다: ${err.message}`);
        setLoading(false);
      });
  }, [location, pdfUrl]);

  if (loading) {
    return <div>로딩 중...</div>;
  }
  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div style={{ width: '100%', height: '150vh', display: 'flex', flexDirection: 'column' }}>
      {
        isMobile
        &&
        <div className="commonButton">
          <Link className='black' to={ pdfUrl } target='_blank' style={{ width: 'fit-content', marginTop: '-24px', borderRadius: '50%', padding: '4px', marginLeft: 'auto' }}>
            <div className="commonIcon mobile">
              <i className='downloadWhite w20'></i>
            </div>
          </Link>
        </div>

      }
      {
        isMobile
        ?
        (
          <Document
            file={ pdfUrl }
            onLoadSuccess={ onLoadSuccess } // 로드 성공 시 페이지 수 설정
            onLoadError={ onLoadError }     // 로드 실패 시 에러 출력
          >
          {
            Array.from(new Array(numPages), (el, index) => (
              <Page
                key={ index + 1 }
                pageNumber={ index + 1 }
                scale={ scale }
                renderTextLayer={ true }      // 텍스트 레이어 렌더링 활성화
                renderAnnotationLayer={true}  // 주석 레이어(링크 등) 렌더링 활성화
                onClick={(e) => {
                  const linkElement = e.target.closest('a');
                  if (linkElement) {
                    handleLinkClick(e, linkElement.href);
                  }
                }}
              />
            ))
          }
        </Document>
        )
        :
        (
          <iframe
            src={`${ pdfUrl }&embedded=true`}
            title="포트폴리오 PDF 미리보기"
            width="100%"
            height='80%'
            frameBorder="0"
            style={{ border: 'none', flex: 1 }}
          />
        )
      }
    </div>
  );
};

export default PDFViewer;